import React, { forwardRef } from 'react';

import { BaseMenuOption } from 'src/editor/toolbars/menus/BaseMenuOption';
import type { CommonMenuItemProps } from 'src/editor/toolbars/menus/types';
import { tablePropertiesDialogOpenVar } from 'src/editor/toolbars/ToolbarMenus';

export const OpenTablePropertiesMenuItem = forwardRef(function InsertTableColumnMenuItem(
  { closeRootMenu }: CommonMenuItemProps,
  ref: React.Ref<HTMLLIElement>
): JSX.Element {
  function openTablePropertiesDialog() {
    closeRootMenu();
    tablePropertiesDialogOpenVar(true);
  }

  return <BaseMenuOption ref={ref} label="Table properties" onClick={openTablePropertiesDialog} />;
});
